import React, { useState } from 'react';
import './EditPeople.css';
import EditStore from './EditStore';

const peopleData = [
  {
    id: 1,
    name: 'Jane Doe',
    title: 'Software Engineer at XYZ Corp',
    location: 'San Francisco, CA',
    picture: 'https://via.placeholder.com/150',
    summary: 'Experienced developer specializing in React.js.',
    experience: ['Frontend Developer at ABC', 'Software Engineer at XYZ Corp'],
  },
  {
    id: 2,
    name: 'John Smith',
    title: 'Product Manager at Acme Inc',
    location: 'New York, NY',
    picture: 'https://via.placeholder.com/150',
    summary: 'Seasoned PM with a knack for agile methodologies.',
    experience: ['Associate PM at Acme', 'Product Manager at Acme Inc'],
  },
  {
    id: 3,
    name: 'John Smith',
    title: 'Product Manager at Acme Inc',
    location: 'New York, NY',
    picture: 'https://via.placeholder.com/150',
    summary: 'Seasoned PM with a knack for agile methodologies.',
    experience: ['Associate PM at Acme', 'Product Manager at Acme Inc'],
  },
  {
    id: 4,
    name: 'John Smith',
    title: 'Product Manager at Acme Inc',
    location: 'New York, NY',
    picture: 'https://via.placeholder.com/150',
    summary: 'Seasoned PM with a knack for agile methodologies.',
    experience: ['Associate PM at Acme', 'Product Manager at Acme Inc'],
  },
  {
    id: 5,
    name: 'John Smith',
    title: 'Product Manager at Acme Inc',
    location: 'New York, NY',
    picture: 'https://via.placeholder.com/150',
    summary: 'Seasoned PM with a knack for agile methodologies.',
    experience: ['Associate PM at Acme', 'Product Manager at Acme Inc'],
  },
  {
    id: 6,
    name: 'John Smith',
    title: 'Product Manager at Acme Inc',
    location: 'New York, NY',
    picture: 'https://via.placeholder.com/150',
    summary: 'Seasoned PM with a knack for agile methodologies.',
    experience: ['Associate PM at Acme', 'Product Manager at Acme Inc'],
  },
  {
    id: 7,
    name: 'John Smith',
    title: 'Product Manager at Acme Inc',
    location: 'New York, NY',
    picture: 'https://via.placeholder.com/150',
    summary: 'Seasoned PM with a knack for agile methodologies.',
    experience: ['Associate PM at Acme', 'Product Manager at Acme Inc'],
  },
  // Add more profiles as needed...
];

const initialAssociatedMembersData = [
  { id: 1, category: "Where they live", subcategory: "India", count: 18041 },
  { id: 2, category: "Where they live", subcategory: "Greater Delhi Area", count: 4340 },
  { id: 3, category: "Where they live", subcategory: "Delhi, India", count: 2586 },
  { id: 4, category: "Where they live", subcategory: "New Delhi", count: 2113 },
  { id: 5, category: "Where they studied", subcategory: "Delhi University", count: 332 },
  { id: 6, category: "Where they studied", subcategory: "Indira Gandhi National Open University", count: 103 },
  { id: 7, category: "Where they studied", subcategory: "Amity University", count: 101 },
  { id: 8, category: "Where they studied", subcategory: "Guru Gobind Singh Indraprastha University", count: 86 },
];

const EditPeople = () => {
  const [associatedMembersData, setAssociatedMembersData] = useState(initialAssociatedMembersData);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [profilesToShow, setProfilesToShow] = useState(2); // Initial profiles to show

  // Access the API URL from environment variables
  const API_URL = process.env.REACT_APP_API_URL || 'https://pyate-backend-production-9749.up.railway.app';

  const profilesPerPage = 2;
  const totalPages = Math.ceil(peopleData.length / profilesPerPage);

  const filteredProfiles = peopleData.filter((profile) =>
    profile.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleConnect = async (id) => {
    try {
      // Extract user information from the profile (this can vary based on your UI design)
      const userId = 1; // You may need to dynamically fetch this based on the logged-in user
      const connectId = 1; // Profile ID to connect with
      const location = "Some Location"; // You might want to pass actual data here
      const education = "Some Education"; // You might want to pass actual data here

      // Make a POST request to the backend API
      const response = await fetch(`${API_URL}/connect`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: userId,
          connect_id: connectId,
          location: location,
          education: education,
        }),
      });

      const data = await response.json();
      if (response.ok) {
        alert(`Connection request sent to profile ID: ${id}`);
      } else {
        alert(`Error: ${data.error}`);
      }
    } catch (error) {
      console.error("Error sending connection request:", error);
      alert("An error occurred while sending the connection request.");
    }
  };


  const handleAdd = async (type) => {
    const newItem = prompt(`Add a new ${type}:`);
    if (!newItem) return; // Prevent empty input
  
    // Log to make sure the data is correct
    console.log("Adding item:", newItem, "Type:", type);
  
    const existingEntryIndex = associatedMembersData.findIndex(
      (entry) => entry.subcategory === newItem
    );
  
    if (existingEntryIndex !== -1) {
      // Update existing entry count
      const updatedData = [...associatedMembersData];
      updatedData[existingEntryIndex].count += 1;
      setAssociatedMembersData(updatedData);
    } else {
      // Add a new entry
      const newId = associatedMembersData.length + 1;
      const newEntry = {
        id: newId,
        category: type === 'place' ? 'Where they live' : 'Where they studied',
        subcategory: newItem,
        count: 1,
      };
      setAssociatedMembersData([...associatedMembersData, newEntry]);
  
      // 🔹 Call API to update the database without page_id
      const payload = {
        user_id: 1,  // Replace with actual user ID
        ...(type === 'place' ? { location_name: newItem } : { education_name: newItem }),
      };
  
      console.log("Sending to backend:", payload); // Log the payload being sent
  
      try {
        const response = await fetch(`${API_URL}/people/add_location_or_education`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify(payload),
        });
  
        const result = await response.json();
        console.log("Backend response:", result);  // Log the response from the backend
        if (!response.ok) throw new Error(result.error || 'Failed to update database');
  
        alert(result.message);
      } catch (error) {
        console.error("⚠️ Error adding location/education:", error);
        alert("Failed to update database: " + error.message);
      }
    }
  };
  
  return (
    <>
      <div className='container-editpeople'>
        <div className="people-page-editpeople">
          <div className="associated-members-editpeople">
            <h1>16,752 Associated Members</h1>

            {/* Search Bar */}
            <div className="search-bar-editpeople">
              <input
                type="text"
                placeholder="Search people..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="associated-members-sections-editpeople">
              <div className="associated-members-section-editpeople">
                <h2>Where they live
                  <button className="add-btn-editpeople" onClick={() => handleAdd('place')}>
                    + Add
                  </button>
                </h2>
                {associatedMembersData
                  .filter((item) => item.category === "Where they live")
                  .map((item) => (
                    <div key={item.id} className="data-row-editpeople">
                      <p>{item.subcategory}</p>
                      <div className="bar-container-editpeople">
                        <div
                          className="bar-editpeople"
                          style={{ width: `${(item.count / 18041) * 100}%` }}
                        ></div>
                      </div>
                      <p>{item.count}</p>
                    </div>
                  ))}
              </div>

              <div className="associated-members-section-editpeople">
                <h2>Where they studied  
                  <button className="add-btn-editpeople" onClick={() => handleAdd('education')}>
                    + Add
                  </button>
                </h2>
                {associatedMembersData
                  .filter((item) => item.category === "Where they studied")
                  .map((item) => (
                    <div key={item.id} className="data-row-editpeople">
                      <p>{item.subcategory}</p>
                      <div className="bar-container-editpeople">
                        <div
                          className="bar-editpeople"
                          style={{ width: `${(item.count / 18041) * 100}%` }}
                        ></div>
                      </div>
                      <p>{item.count}</p>
                    </div>
                  ))}
              </div>
            </div>
          </div>

          {/* Profiles List */}
          <div className='container-editpeople'>
            <div className="people-list-editpeople">
              {filteredProfiles.map((profile) => (
                <div
                  key={profile.id}
                  className="people-card-editpeople"
                  onClick={() => setSelectedProfile(profile)}
                >
                  <img src={profile.picture} alt={`${profile.name}'s profile`} />
                  <h3>{profile.name}</h3>
                  <p>{profile.title}</p>
                  <p>{profile.location}</p>
                  <button onClick={() => handleConnect(profile.id)}>Connect</button>
                </div>
              ))}
            </div>

            {/* Profile Details Modal */}
            {selectedProfile && (
              <div className="people-details-editpeople">
                <button className="close-btn-editpeople" onClick={() => setSelectedProfile(null)}>
                  Close
                </button>
                <img src={selectedProfile.picture} alt={`${selectedProfile.name}'s profile`} />
                <h2>{selectedProfile.name}</h2>
                <p>{selectedProfile.title}</p>
                <p>{selectedProfile.location}</p>
                <p>{selectedProfile.summary}</p>
                <h3>Experience</h3>
                <ul>
                  {selectedProfile.experience.map((exp, idx) => (
                    <li key={idx}>{exp}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};


export default EditPeople;